var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var CloseIcon = function CloseIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1755 2048' }),
    React.createElement('path', { d: 'M0 1586l709-709L0 169 169 0l709 708L1586 0l169 169-708 708 708 709-169 169-708-709-709 709z' })
  );
};
export default CloseIcon;